<div class="container-fluid padMob bg webView" style="padding-left: 15px; padding-right: 0px;">
    <div class="row" style="margin: 0px;">
        <!-- Header-->
        <div class="col-md-12 col-12 col-sm-12 padZero bgWhite padHeder"  style="padding-bottom: 0px;">
            <div class="col-md-6 col-sm-12 col-12 inLneBlk padZero" style="display: inline-block;">
                <span class="newHeader" style="font-weight: 500; font-size: 32px;">Inventory Reports</span>&nbsp;&nbsp;
                <!-- <span style="font-size: 17px;">
                    Coming Soon
                </span> -->
            </div>
            <div class="col-md-6 col-sm-12 col-12 inLneBlk padZero" style="display: inline-block; text-align: right;">
                <span class="btn-blue brdrRadius3" style="font-size: 13px; display: inline-block; padding: 3px 12px 3px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>
       </div>

       <!-- Body-->
       <div class="col-md-12 col-12 col-sm-12 bgWhite">
            <div class="col-md-12 padZero" style="margin-top: 15px; margin-bottom: 30px;" *ngFor="let i of reportArr;" >
                <div class="divHeaderForCard padZero" >
                    <span  class="{{i.titleColorCls}}"> {{i.title}} </span>
                </div>

                <div class="row padZero" style="margin: 0px;">
                    <div class="col-md-3 alignClass" style="padding-left: 0px;" *ngFor="let r of i.reportItems;">
                        <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="InventoryReportsRedirect(r.index)" >
                            <div class="dashBox-coloured-header brdrRadius3 {{i.itemHeaderColorCls}}">
                                <h3 class="dashBox-title ellipsis" style="font-size: 17px;">{{r.title}}</h3>
                            </div>
                            <div>
                                <p class="dashBox-category overrideDescriptionBottomCard reportDesc" style="line-height: 22px;">{{r.desc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</div>